import React from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

interface ContentWrapperProperty {
	className?: string;
	style?: React.CSSProperties;
	children: React.ReactNode;
}

const ContentWrapper: React.FC<ContentWrapperProperty> = ({ className, style, children }) => (
	<section className={classnames(styles.contentWrapper, className)} style={style}>
		{children}
	</section>
);

export default ContentWrapper;
